// @flow
import styled from 'styled-components';

const FormWrapper = styled.div`
    display: flex;
    height: 100%;

    & .scrollable {
        height: calc(100vh - 141px);
    }
`;

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/components/shared/FormWrapper.js